<style lang="scss">
.zoezi-toolbox {
    position: fixed;
    z-index: 100;
    background:#eee;
    transition: all 250ms ease-in-out;
    transition-property: opacity, transform;
    /*opacity:.9;*/
    border-radius:5px;
}

.zoezi-toolbox:hover{
    opacity:1;
}
.zoezi-toolbox.moving{
    opacity:.6;
}

.movecursor {
    cursor: move;
    user-select: none;
}
.zoezi-toolbox .v-icon.mdi-chevron-up{transition:all 250ms ease-in-out}
.zoezi-toolbox.minimized .v-icon.mdi-chevron-up{transform:rotate(180deg)}

.resizable .resizers .resizer{
  width: 10px;
  height: 10px;
  position: absolute;
}
.resizable .resizers .resizer.bottom-right {
  right: -5px;
  bottom: -5px;
  cursor: nwse-resize;
}
</style>

<template>
    <portal to="toolbox">
        <div ref="c" class="zoezi-toolbox elevation-4 resizable" :style="{left: left + 'px', top: top + 'px', width: width == 'unset' ? 'unset' : width + 'px', height: height == 'unset' ? 'unset' : height + 'px', maxWidth: maxWidth}" :class="{moving : isDown, minimized : isMinimized}" v-click-outside="clickOutside">
            <div class="d-flex movecursor" @mousedown.left="onMouseDown" @touchstart.prevent="onTouchStart" @dblclick="toggleToolbox">
                <v-icon>mdi-drag</v-icon>
                <div class="px-2 text-caption" style="line-height:2em" v-text="label" />
                <v-spacer />

                <v-icon v-if="close" @click="$emit('close')" @touchstart.stop="">mdi-close</v-icon>
                <v-icon v-else @click="toggleToolbox" :title="$translate('Double-click on the title bar to minimize/maximize')">mdi-chevron-up</v-icon>
            </div>

            <v-expand-transition>
                <div v-if="!isMinimized">
                    <slot />
                </div>
            </v-expand-transition>

            <div class="resizers" v-if="resize">
                <div class="resizer bottom-right" @mousedown="onResize"/>
            </div>
        </div>
    </portal>
</template>

<script>
export default {
    name: 'zoezi-toolbox-window',

    props: {
        label: {
            type: String
        },
        close: {
            type: Boolean,
            default: false
        },
        center: {
            type: Boolean,
            default: false
        },
        resize: {
            type: Boolean,
            default: false
        },
        maxWidth: {},
        initialX: {
            type: Number,
            default: 100
        },
        initialY: {
            type: Number,
            default: 100
        },
        persistent: {
            type: Boolean,
            default: true
        }
    },

    data: () => ({
        left: 100,
        top: 100,
        width: 'unset',
        height: 'unset',
        isDown: false,
        isMinimized: false,
        show: true,
        original_width: null,
        original_height: null,
        original_x: null,
        original_y: null,
        original_mouse_x: null,
        original_mouse_y: null,
        resizeTarget: null,
        previousTouchX: null,
        previousTouchY: null
    }),

    computed: {
        clickOutside() {
            return {
                handler: () => {
                    if (!this.persistent) {
                        this.$emit('close');
                    }
                },
                isActive: !this.persistent
            }
        }
    },

    methods: {
        toggleToolbox(){
            if (!this.close) {
                this.isMinimized = !this.isMinimized;
            }
        },
        onMouseDown() {
            this.isDown = true;
            window.addEventListener('mousemove', this.onMouseMove);
        },
        onTouchStart(event) {
            this.isDown = true;
            const touch = event.touches[0];
            this.previousTouchX = touch.clientX;
            this.previousTouchY = touch.clientY;

            window.addEventListener('touchmove', this.onTouchMove, { passive: false });
            window.addEventListener('touchend', this.onTouchEnd);
        },
        onTouchMove(event) {
            if (!this.isDown) return;

            event.preventDefault();

            const currentTouch = event.touches[0];

            const movementX = currentTouch.clientX - this.previousTouchX;
            const movementY = currentTouch.clientY - this.previousTouchY;

            this.left += movementX;
            this.top += movementY;

            this.previousTouchX = currentTouch.clientX;
            this.previousTouchY = currentTouch.clientY;
        },
        onTouchEnd() {
            this.isDown = false;
            window.removeEventListener('touchmove', this.onTouchMove);
            window.removeEventListener('touchend', this.onTouchEnd);
        },
        onMouseMove(event) {
            if (this.isDown) {
                event.preventDefault();
                this.left = Math.max(0, this.left + event.movementX);
                this.top = Math.max(0, this.top + event.movementY);
            }
        },
        onMouseUp() {
            this.isDown = false;
            window.removeEventListener('mousemove', this.onMouseMove);
            if(this.left > window.innerWidth) this.left = window.innerWidth - 50;
            if(this.top > window.innerHeight) this.top = window.innerHeight - 50;
        },
        doResize(e) {
            let dx = e.clientX - this.original_mouse_x;
            let dy = e.clientY - this.original_mouse_y;
            let width = this.original_width + dx;
            let height = this.original_height + dy;
            this.width = width;
            this.height = height;
        },
        stopResize() {
            window.removeEventListener('mousemove', this.doResize);
            window.removeEventListener('mouseup', this.stopResize);
        },
        onResize(e) {
            e.preventDefault();
            this.original_width = this.$refs.c.clientWidth;
            this.original_height = this.$refs.c.clientHeight;
            this.original_x = this.left;
            this.original_y = this.top;
            this.original_mouse_x = e.clientX;
            this.original_mouse_y = e.clientY;
            window.addEventListener('mousemove', this.doResize);
            window.addEventListener('mouseup', this.stopResize);
        }
    },

    mounted() {
        // Constants for offset
        const OFFSET_X = 15;  // Horizontal offset in pixels
        const OFFSET_Y = 15;  // Vertical offset in pixels

        this.$nextTick(() => {
            if (this.center) {
                let width = this.$refs.c.clientWidth;
                let height = this.$refs.c.clientHeight;
                const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
                const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
                this.left = (vw - width) / 2;
                this.top = (vh - height) / 2;
            } else {
                // Calculate position with offset
                let calculatedX = this.initialX + OFFSET_X;
                let calculatedY = this.initialY + OFFSET_Y;

                // Ensure the toolbox doesn't go off the right edge of the screen
                if (calculatedX + this.$refs.c.offsetWidth > window.innerWidth) {
                    calculatedX = window.innerWidth - this.$refs.c.offsetWidth - OFFSET_X;
                }

                // Ensure the toolbox doesn't go off the bottom edge of the screen
                if (calculatedY + this.$refs.c.offsetHeight > window.innerHeight) {
                    calculatedY = window.innerHeight - this.$refs.c.offsetHeight - OFFSET_Y;
                }

                // Set the calculated position
                this.left = calculatedX;
                this.top = calculatedY;
            }
        })

        window.addEventListener('mouseup', this.onMouseUp);
    },

    destroyed() {
        window.removeEventListener('mouseup', this.onMouseUp);
    }
}
</script>
